import Axios from "../../configs/axios.config";

/* Folder */
export const createFolder = (data) => Axios.post(`/common/folders`, data);
export const updateFolder = (id, data) => Axios.put(`/common/folders/${id}`, data);
export const getFolders = (data) => Axios.get(`/common/folders`, { params: data }).then((res) => res.data);
export const deleteFolder = (id) => Axios.delete(`/common/folders/${id}`);
export const detailFolder = (id) => Axios.get(`/common/folders/${id}`).then((res) => res.data);
export const downloadFolder = (data) => Axios.get(`/common/folders/shared/download`, { params: data }).then((res) => res);

export const deleteFile = (data) => Axios.delete(`/common/folders/files/delete-multiple`,  { params: data }).then((res) => res);


// export const folderFullDetail = (id) => Axios.get(`/common/folders/${id}`).then((res) => res.data);
export const folderFullDetail = (id, data) => Axios.get(`/common/folders/${id}`, { params: data }).then((res) => res.data);


/* Folder */

/* File */
export const createFile = (data) => Axios.post(`/common/folders/upload-file`, data);
 
/* File */


/* Share Folder */
export const shareFolder = (data) => Axios.post(`/common/folders/share`, data);
export const shareUpdateFolder = (id, data) => Axios.put(`/common/folder/share/${id}`, data);
export const getShareFolders = (data) => Axios.get(`/common/folders/share`, { params: data }).then((res) => res.data);
export const deleteShareFolder = (id) => Axios.delete(`/common/folder/share/${id}`);
export const detailShareFolder = (id) => Axios.get(`/common/folders/share/${id}`).then((res) => res.data.data);